import { render, staticRenderFns } from "./PaymentIcon.vue?vue&type=template&id=10be5305&"
import script from "./PaymentIcon.vue?vue&type=script&lang=js&"
export * from "./PaymentIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports